export const environment = {
    production: false,
    default_published_url: "app-rc.gurumatch.com.br",
    default_subscription_id: "07b088fb-7db5-4f6b-ae31-6bf9e167b1ce",
    loginSocial: {
        google: {
            clientId: "1772391100-cjstr2mv4roglcmcg7m49gjlkf833u11.apps.googleusercontent.com"
        },
        facebook: {
            appId: "988359511576734"
        }
    },
    iugu: {
        production: true,
        CDN: "https://js.iugu.com/v2"
    },
    dom_pagamentos: {
        production: false,
        SDK_production: "https://apiv3.dompagamentos.com.br/js/sdk-dompagamentos.min.js",
        SDK_sandbox: "https://hml-apiv3.dompagamentos.com.br/js/sdk-dompagamentos.min.js"
    },
    identity: {
        url: "https://api-identity-rc.gurumatch.com.br",
        client_id: ""
    },
    user: {
        url: "https://api-user-rc.gurumatch.com.br"
    },
    courses: {
        url: "https://api-courses-rc.gurumatch.com.br"
    },
    featured: {
        url: "https://api-user-interests-rc.gurumatch.com.br"
    },
    notifications: {
        url: "https://api-notifications-rc.gurumatch.com.br"
    },
    subscriptions: {
        url: "https://api-subscriptions-rc.gurumatch.com.br"
    },
    streamingClass: {
        url: "https://api-streamingclass-rc.gurumatch.com.br"
    },
    billing: {
        url: "https://api-billing-rc.gurumatch.com.br"
    },
    streaming: {
        url: "https://api-streaming-rc.gurumatch.com.br"
    },
    coursesCatalog: {
        url: "https://api-courses-catalog-rc.gurumatch.com.br"
    },
    exams: {
        url: "https://api-exams-rc.gurumatch.com.br"
    },
    userCourses: {
        url: "https://api-user-courses-rc.gurumatch.com.br"
    },
    fiscal: {
        url: "https://api-fiscal-rc.gurumatch.com.br"
    },
    storage: {
        url: "https://api-storage-rc.gurumatch.com.br"
    },
    gamification: {
        url: "https://api-gamification-rc.gurumatch.com.br"
    },
    communication: {
        url: "https://api-communication-rc.gurumatch.com.br"
    },
    s3output: "https://rc-gurumatch-video-output.s3-accelerate.amazonaws.com",
    forceCoursesCatalog: false,
    checkVersion: false,
    debbug: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
